// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
export enum PlatformStatuses {
  operational = 1,
  inMaintenance = 2,
  inventory = 3,
  defectiveReturned = 4,
  other = 5
}

export const PLATFORM_STATUSES_LABELS = {
  [PlatformStatuses.operational]: 'Operational',
  [PlatformStatuses.inMaintenance]: 'In-Maintenance',
  [PlatformStatuses.inventory]: 'Inventory',
  [PlatformStatuses.defectiveReturned]: 'Defective/Returned',
  [PlatformStatuses.other]: 'Other'
};

export const PLATFORM_FIELDS = {
  companyId: 'companyId',
  id: 'id',
  serialNumber: 'serialNumber',
  status: 'status',
  platformOwnerShip: 'platformOwnerShip',
  drone: {
    name: 'drone',
    fields: {
      manufacturerName: 'manufacturerName',
      manufacturerId: 'manufacturerId',
      modelId: 'modelId',
      modelName: 'modelName',
      name: 'name',
      serialNumber: 'serialNumber',
      batteriesCount: 'batteriesCount',
      controllerName: 'controllerName',
      maxFlightTime: 'maxFlightTime'
    }
  },
  payloadHardware: {
    name: 'payloadHardware',
    fields: {
      cameras: 'cameras',
      gimbals: 'gimbals',
      gimbalBattery: 'gimbalBattery',
      lenses: 'lenses',
      gpsProvider: 'gpsProvider'
    }
  },
  payloadSoftware: {
    name: 'payloadSoftware',
    fields: {
      version: 'version',
      installDate: 'installDate',
    }
  },
  isBlocked: 'isBlocked',
  isActive: 'isActive',
  dronModel: 'dronModel',
  lastUsedAt: 'lastUsedAt'
};